import React from "react";
import ComponentHeader from "./ComponentHeader";
import { BsThreeDotsVertical } from "react-icons/bs";
import AddBox from "./AddBox";
import { ReactComponent as UpcomingSession } from "../../svg/UpcomingSessionsSvg.svg";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { List } from "@mui/material";
import { Dropdown } from "react-bootstrap";
import { useState } from "react";
import {
  onStartSession,
  showToastError,
  showToastSuccess,
  sortArrLatest,
} from "../../Utils/Helper";
import ShareLinkModal from "../carePlan_/ShareLinkModal";
import DeleteModal from "../../commonComponent/DeleteModal";
import {
  deleteSessionService,
  getActiveProgramById,
} from "../../services/ActivePrograms";
import { useEffect } from "react";
import AddEditNotesModal from "../activeProgram/AddEditNotesModal";
import Loader from "../../commonComponent/Loader";
import { getUpcomingSessionList } from "../../services/DashboardService";

function UpcomingSessions({ isLoading, filter }) {
  const navigate = useNavigate();
  const [sessionList, setSessionList] = useState(); // eslint-disable-next-line
  const [viewSession, setViewSession] = useState(false);
  const [session, setSession] = useState();
  const [sessionId, setSessionId] = useState();
  const [programId, setProgramId] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [operation, setOperation] = useState("add");
  const [program, setProgramDetails] = useState();

  useEffect(() => {
    getSessionList(`${moment(filter).format("YYYY-MM-DD")}`);
  }, [filter]);

  const getActiveProgramByIds = async (programId, session, viewSession) => {
    let programDetails;
    try {
      const response = await getActiveProgramById(programId);
      if (response.status === 200) {
        programDetails = response?.data?.data[0];
        setProgramDetails(programDetails);
        setSession(session);
        if (programDetails && session && viewSession) {
          navigate("/activeprogram", {
            state: {
              program: programDetails,
              isFromCreate: false,
              isRedirectedFromDashboard: true,
              session: session,
              viewSession: viewSession,
            },
          });
        }
        if (programDetails && !session && !viewSession) {
          navigate("/activeprogram", {
            state: {
              program: programDetails,
              isFromCreate: false,
              isRedirectedFromDashboard: true,
              session: session,
              viewSession: viewSession,
            },
          });
        }
      } else {
        console.log(response?.data || response.message);
      }
    } catch (error) {
      console.log(error?.data || error.message);
    }
  };

  const getSessionList = async (date) => {
    setSessionList([]);
    try {
      const response = await getUpcomingSessionList(date);
      if (response.status === 200) {
        setSessionList(sortArrLatest(response?.data));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const deleteSession = async () => {
    try {
      const response = await deleteSessionService(sessionId, programId);
      if (response) {
        showToastSuccess(response?.data || "Session deleted successfully.");
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };
  return (
    <>
      <ComponentHeader
        title={"Upcoming Sessions"}
        // filter={<BsFillPlayFill size={"20px"} color="rgba(31, 126, 120, 1)" className="m-2" />}
        // descript={"View All"}
        handleClick={() => navigate("/todayappointment")}
      />
      <div
        style={{ maxHeight: "650px", overflowY: "scroll" }}
        className={
          sessionList?.length > 0
            ? sessionList?.length < 3
              ? " overflow-visible shadow rounded-4 d-flex flex-column align-items-start w-100 "
              : "py-3 Dash shadow rounded-4 d-flex flex-column align-items-start w-100 "
            : "shadow rounded-4 mb-5 d-flex flex-column justify-content-center  align-items-start w-100"
        }
      >
        <List className="d-flex flex-column justify-content-center  align-items-center w-100 h-100  resFont">
          {isLoading ? (
            <Loader
              visible={isLoading}
              style={{ top: "-15px", position: "relative" }}
            />
          ) : sessionList?.length > 0 ? (
            sessionList?.map((session, index) => {
              return (
                <>
                  <div
                    key={session._id}
                    className="d-flex justify-content-between align-items-center w-100 h-100 "
                  >
                    <div
                      className="col-sm-7 col-md-8 col-lg-8 mb-3 ps-2 pointer d-flex align-items-center "
                      onClick={() => {
                        getActiveProgramByIds(session.programId, session, true);
                        setSession(session);
                        setViewSession(true);
                      }}
                      style={{height:'60px'}}
                    >
                        <div className="p-2 d-flex flex-column justify-content-center w-100">
                          <span className="fw-bold resFont w-100 text-truncate ">
                            {session?.programName}
                          </span>
                          <span className="fw-semibold resFont w-100 text-truncate">
                            <small className="text-muted">
                              {session?.title}
                            </small>
                          </span>
                          <span className="fw-semibold resFont">
                            <small className="text-muted">
                              Last updated{" "}
                              {moment(new Date(session.createdAt)).fromNow()}
                            </small>
                          </span>
                        </div>
                    </div>
                    <div className="col-sm-5 col-md-4 col-lg-4  d-flex align-items-center justify-content-end ">
                      <div className="">
                        <button
                          className="btn rounded-5 btn-sm resFont px-3"
                          style={{
                            backgroundColor: "rgba(227, 236, 237, 1)",
                            color: "rgba(31, 126, 120, 1)",
                            borderRadius: "5px",
                          }}
                          onClick={() =>
                            onStartSession(session?.sessionLink_doctor)
                          }
                        >
                          Start Session
                        </button>
                      </div>
                      <div className="">
                        <Dropdown
                          style={{
                            width: "max-content",
                            height: "max-content",
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Dropdown.Toggle
                            // onClick={(e)=>e.stopPropagation()}
                            variant="transparent"
                            className="custom d-flex align-content-center "
                            id="dropdown-basic"
                            style={{
                              color: "rgba(201, 204, 206, 1)",
                            }}
                          >
                            <BsThreeDotsVertical />
                          </Dropdown.Toggle>
                          <Dropdown.Menu
                            style={{ zIndex: "1000" }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <Dropdown.Item
                              onClick={() => {
                                getActiveProgramByIds(
                                  session.programId,
                                  session,
                                  true
                                );
                                setSession(session);
                                setViewSession(true);
                              }}
                            >
                              View session
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                getActiveProgramByIds(session.programId);
                                setSession(session);
                                setViewSession(true);
                              }}
                            >
                              Edit session
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                getActiveProgramByIds(
                                  session.programId,
                                  session
                                );
                                setModalShow(true);
                                setOperation("add");
                              }}
                            >
                              Write Notes
                            </Dropdown.Item>
                            <Dropdown.Item
                              href="#/action-4"
                              data-bs-toggle="modal"
                              data-bs-target="#shareModal"
                            >
                              Share session
                            </Dropdown.Item>
                            <Dropdown.Item
                              href="#/action-5"
                              data-bs-toggle="modal"
                              data-bs-target="#deleteSession"
                              onClick={() => {
                                setSessionId(session._id);
                                setProgramId(session.programId);
                              }}
                            >
                              Cancel session
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                    <ShareLinkModal link={session?.sessionLink_doctor} />
                    <DeleteModal
                      title={"Delete"}
                      content1={"Are you sure you want to delete"}
                      content2={"this Session?"}
                      modalId={"deleteSession"}
                      button2={"No"}
                      button1={"Yes"}
                      onDelete={() => deleteSession()}
                    />
                  </div>
                  {index === sessionList?.length - 1 ? null : (
                    <hr
                      style={{
                        border: "0",
                        clear: "both",
                        display: "block",
                        width: "96%",
                        backgroundColor: "rgba(237, 237, 237, 1)",
                        height: "2px",
                      }}
                    />
                  )}
                </>
              );
            })
          ) : (
            <AddBox
              handleClick={() => {
                navigate("/calender");
              }}
              svg={<UpcomingSession />}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "transparent",
                textAlign: "center",
                width: "100%",
                height: "500px",
              }}
              header="You do not have any sessions scheduled yet 
          Set up your availability by clicking "
              header2="here."
              content={""}
            />
          )}
        </List>
        <AddEditNotesModal
          pid={program?._id}
          sid={session?._id}
          show={modalShow}
          operation={operation}
          getProgram={() => {}}
          onHide={() => setModalShow(false)}
        />
      </div>
    </>
  );
}

export default UpcomingSessions;
